import dayjs from "dayjs";
import { FYResult } from "../types";
import { formatUnixTimestamp } from "../../../library";

export function computeFY(selectedOption: string, selectedYear: number): FYResult {
    const isCalendar = selectedOption === 'CALENDAR';
    const startYear = selectedYear;
    const endYear = isCalendar ? selectedYear : selectedYear + 1;
    const startDateObj = isCalendar ? dayjs(`${startYear}-01-01`) : dayjs(`${startYear}-04-01`);
    const endDateObj = isCalendar ? dayjs(`${endYear}-12-31`).endOf('day') : dayjs(`${endYear}-03-31`).endOf('day');
    const startDateTimestamp = Math.floor(startDateObj.valueOf() / 1000);
    const endDateTimestamp = Math.floor(endDateObj.valueOf() / 1000);
    const fyPreview = `${formatUnixTimestamp(startDateTimestamp)} to ${formatUnixTimestamp(endDateTimestamp)}`;
    return { startDateTimestamp, endDateTimestamp, fyPreview };
  }
